import React, { useState, useMemo } from "react";
import styles from "./DiamondInfoItem.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";

import CheckMark from "./Checked_In_Icon.svg";
import ProxyCheckmark from "../ProxyCheckmark";
import AccessLevel from "../AccessLevel";
import DiamondCardModal from "../DiamondCardModal";
import InPersonIcon from "../../Shared/InPersonMeetingIcon/In_Person_Icon.png";
import { Dashboard } from "../useDashboard";

/**
 *
 * Displays the basic information for a diamond and is used in the diamonds list card. Clicking the item will open a modal to view/edit the diamonds info.
 *
 */

export function DiamondInfoItem({ diamondInfo, onClickProfile, isHideInfo }) {
  const [diamondModalInfo, setDiamondInfoModal] = useState(null);

  useMemo(() => {
    setDiamondInfoModal({
      userId: diamondInfo.userId,
      canSwap: diamondInfo.canSwap,
      picture: diamondInfo.photo || InPersonIcon,
      name: `${diamondInfo.firstName} ${diamondInfo.lastName}`,
      phoneNumber: diamondInfo.phoneNumber,
      email: diamondInfo.email,
      address: diamondInfo.address,
      accessLevel: diamondInfo.accessLevel,
      spouse: diamondInfo.spouse,
      iboNum: diamondInfo.iboNum,
      birthdate: diamondInfo.birthdate,
      anniversary: diamondInfo.anniversary,
      pinLevel: diamondInfo.pinLevel,
      uplineDiamond: diamondInfo.uplineDiamond,
      yearDiamondQualified: diamondInfo.yearDiamondQualified,
      yearQualified: diamondInfo.yearQualified,
      gracePeriod: diamondInfo.gracePeriod,
      gracePeriodStarted: diamondInfo.gracePeriodStarted,
      familyReunion: diamondInfo.familyReunion,
      firstFamilyReunion: diamondInfo.firstFamilyReunion,
      familyReunionAttendance: diamondInfo.familyReunionAttendance,
      garPoints: diamondInfo.garPoints,
      integratedGarPoints: diamondInfo.integratedGarPoints,
      diamondRankGar: diamondInfo.diamondRankGar,
      diamondRankWwg: diamondInfo.diamondRankWwg,
      votingMember: diamondInfo.votingMember,
      votingMemberYear: diamondInfo.votingMemberYear,
      executiveCommittee: diamondInfo.executiveCommittee,
      yearQualifyingRequirements: diamondInfo.yearQualifyingRequirements,
      yearExecutiveCommitteeQualified:
        diamondInfo.yearExecutiveCommitteeQualified,
      committees: diamondInfo.committees,
      committeesB: diamondInfo.committeesB,
      iboB: diamondInfo.iboB,
    });
  }, [diamondInfo]);

  const onProfileClick = () => {
    onClickProfile(diamondModalInfo);
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.imageContainer}>
          <img
            src={diamondInfo.photo}
            className={styles.image}
            onClick={onProfileClick}
            alt="Profile"
          />
          {diamondInfo.proxyCheckedIn && (
            <div className={styles.checkMark}>
              <ProxyCheckmark />
            </div>
          )}
          {diamondInfo.checkedIn && !diamondInfo.proxyCheckedIn && (
            <div className={styles.checkMark}>
              <img src={CheckMark} alt="Checked In" />
            </div>
          )}
        </div>

        <div className={styles.name}>
          {diamondInfo.firstName.toLowerCase()}{" "}
          {diamondInfo.lastName.toLowerCase()}
        </div>

        <div className={styles.pinLevel}>{diamondInfo.pinLevel}</div>

        <div className={classNames(styles.garPoints)}>
          {!isHideInfo &&
            (diamondInfo.garPoints ? diamondInfo.garPoints.toFixed(1) : 0)}
        </div>

        <div className={styles.accessLevel}>
          <AccessLevel accessLevel={diamondInfo.accessLevel} />
        </div>
      </div>
    </>
  );
}

DiamondInfoItem.propTypes = {
  diamondInfo: PropTypes.object,
  onClickProfile: PropTypes.func,
};
